/* istanbul ignore file */
import { post } from '@/utils/queries';

// const baseAmoebaNewUrl = 'https://financial-analyst.amoebai.com/'; // Original URL
const baseAmoebaNewUrl = 'https://financial-analyst.app.opstart.co/'; // Subdomain

export const getAmoebaToken = async (teamIds: string[]) => {
  const body = {
    teamIds,
  };
  const result = await post<{ token: string }>(`auth/amoeba-token`, body);
  return result.token;
};

export const generateChatbotNewUrlWithoutKey = () => {
  return `${baseAmoebaNewUrl}`;
};

export const generateAmoebaUrlWithToken = async (teamIds: string[]) => {
  const token = await getAmoebaToken(teamIds);
  const domain = (import.meta.env || process.env)
    .VITE_AMOEBA_DOMAIN_TOKEN as string;
  const expires = new Date();
  expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);

  // eslint-disable-next-line max-len
  document.cookie = `auth_token=${token}; domain=${domain}; path=/; expires=${expires.toUTCString()}; secure; samesite=none`;
  return `${baseAmoebaNewUrl}`;
};
